import { useEffect } from 'react';
import type {
  HydrogenNetworkPointCapacitiesRequestParams,
  HydrogenNetworkPointCapacities,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  params: HydrogenNetworkPointCapacitiesRequestParams;
} & OptionalUrlTemplate;

type RequestParams = {
  params: HydrogenNetworkPointCapacitiesRequestParams;
} & UrlTemplate;

export function useHydrogenNetworkPointCapacities({ url, params }: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: RequestParams) =>
      axios.request<HydrogenNetworkPointCapacities>({
        ...baseConfig,
        url,
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  if (!url) return;

  return request;
}

export type HydrogenNetworkPointCapacitiesRequest = ReturnType<
  typeof useHydrogenNetworkPointCapacities
>;
